import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country, ShareHolder } from '../../../domain/data';
import { DocumentType, GetCountriesUseCase, Nature } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-shareholder',
    templateUrl: './full-data-form-shareholder.component.html',
    styleUrls: ['./full-data-form-shareholder.component.scss']
})
export class FullDataFormShareholderComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public Nature: typeof Nature = Nature;
    public DocumentType: typeof DocumentType = DocumentType;

    public prefix: string;
    public countries: Country[] = [];

    @Input()
    shareHolder: ShareHolder;

    @Input()
    owner = false;

    @Input()
    min = 25;

    @Input()
    max = 100;

    @Input()
    isDisabled = false;

    @Output()
    natureChange: EventEmitter<Nature> = new EventEmitter();


    constructor(parentEvents: ParentEvents,
                private dialog: MatDialog,
                private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfsh-${nextUniqueId++}-`;
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase.bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe(transaction => {
                if (transaction.isSuccess) {
                    this.countries = (transaction.data as Country[]);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onNatureChange(nature: Nature) {
        this.natureChange.emit(nature);
        this.parentEvents.resize();
    }
}
